const STATUS_LABELS: Record<string, string> = {
    AUTHORISATION_FAILED: 'Authorization Failed',
    AUTHORISATION_SUCCESS: 'Authorization Success',
    CANCEL_OR_REFUND: 'Cancel',
    CAPTURE: 'Capture',
    PARTIALLY_CAPTURED: 'Partially Captured',
    REFUND: 'Refund',
    PARTIAL_REFUND: 'Partially Refund',
    WAITING_FOR_AUTHORIZATION: 'Waiting for Authorization',
};

function normalizeFallback(key: string): string {
    return key
        .toLowerCase()
        .replace('_', ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function getStatusLabel(status?: string): string {
    if (!status) return '';
    const key = status
    return STATUS_LABELS[key] ?? normalizeFallback(key);
}